import React, { FC } from "react";

import { IconProps } from "..";

import "../Icon.css";

/**
 * N.b. `IconHIndex` kinda "breaks the mold" of other `Icon*` components in two
 * ways:
 *
 * 1. It is not square, and "natively" 73x48 (wider than tall). I think we want
 *    to be able to easily size this thing to fit on a line so we calculate the
 *    width based on the size passed in (assumes `size` is the desired height).
 *    Use it like:
 *    ```
 *    <IconHIndex size={18} /> // width is 73 * (18 / 48) or 27.375
 *    ```
 * 2. It uses it's own colors. I'm going to leave this "in line" for now, but
 *    there may come a time where we'll want each path to have a `className` and
 *    this icon to have it's own CSS file so that we can reuse the theme colors
 *    via CSS `var`s.
 */
export const IconHIndex: FC<IconProps> = ({ size = 48 }) => (
  <svg
    width={73 * (size / 48)}
    height={size}
    viewBox="0 0 73 48"
    className="Icon IconHIndex"
  >
    <g fillRule="evenodd">
      <path
        fill="#ff47ac"
        d="M.373 32l8.498.001c3.18 9.188 11.683 15.804 21.721 15.98l.408.003 2.508.003-.028.013-9.56-.03H23l-.409-.003c-.35-.006-.698-.02-1.044-.04l-.36-.024-.358-.03-.572-.058-.568-.071-.222-.032-.222-.033a23.934 23.934 0 01-1.447-.273l-.348-.08-.475-.118-.509-.137-.268-.077-.459-.14-.564-.187-.492-.176-.422-.16-.183-.073-.536-.222-.53-.235-.336-.157-.341-.166-.338-.171c-.182-.094-.362-.19-.542-.289l-.467-.263a23.999 23.999 0 01-.9-.548l-.211-.137-.523-.352-.355-.25-.135-.098a24.106 24.106 0 01-1.17-.91l-.286-.24-.423-.37-.14-.127a24.147 24.147 0 01-1.618-1.62l-.377-.424-.264-.31-.364-.445-.261-.334-.207-.272-.325-.446-.315-.454-.236-.355-.213-.333-.184-.298-.293-.493-.28-.501-.296-.56-.077-.151a23.857 23.857 0 01-1.055-2.43L.373 32zM23 0l7.301.024-.12.004C20.46.368 12.238 6.755 9.004 15.624l-.134.375H.362l.166-.454.212-.544.174-.419.117-.268.153-.34.158-.337.183-.372.252-.49.208-.384.186-.33.268-.454.207-.336.214-.337.313-.468.325-.464.239-.326.35-.459.361-.45.37-.439.26-.296.37-.405.387-.405.453-.452.372-.352.274-.251.436-.384.446-.373.279-.225.444-.344.31-.23.329-.236.485-.333c.165-.11.33-.219.498-.325l.323-.201.325-.196.313-.181.315-.177.336-.181.338-.176c.393-.2.792-.39 1.197-.569l.58-.247.551-.218.357-.133.37-.131.559-.185.186-.058a23.84 23.84 0 011.693-.455l.414-.091.389-.08.48-.087.483-.078c.313-.048.628-.09.945-.125l.346-.036.348-.03C21.665.026 22.33 0 23 0z"
      />
      <path
        fill="#6a54fe"
        d="M8.871 32.001h8.561c3.252 9.198 11.952 15.823 22.223 15.996L31 47.984c-10.215 0-18.905-6.671-22.129-15.983zM40.02 0l-.365.003c-10.133.17-18.736 6.62-22.088 15.626l-.135.372H8.87C12.006 6.935 20.322.372 30.182.027l.446-.012L40.021 0z"
      />
      <path
        fill="#2482ff"
        d="M25.965 32c3.04 8.599 10.84 14.948 20.234 15.881l.395.036-1.823.034-2.995.04-1.71.009c-10.449 0-19.339-6.678-22.634-16h8.533zM17.432 16C20.683 6.802 29.384.177 39.655.004L40.067 0h1.215l6.25.023C37.69.454 29.385 6.815 26.104 15.622l-.138.379h-8.533z"
      />
      <path
        fill="#08203f"
        d="M48.6 0l.397.003C62.069.215 72.6 10.878 72.6 24c0 13.255-10.745 24-24 24l-.274-.002-.273-.004-.36-.01-.52-.026-.552-.038c-9.582-.783-17.57-7.193-20.656-15.92H51.8a8 8 0 00.25-15.996L51.8 16H25.965C29.153 6.982 37.58.437 47.59.02l.548-.016L48.6 0z"
      />
    </g>
  </svg>
);
